import { createApi } from "@reduxjs/toolkit/query/react";

import { T_WasteManagementData } from "@/interfaces/customer-portal/waste-management.interface";
import { BaseWithAuth, getCustomerId } from "@/utils/helpers";

// Waste Management APIS
export const WasteManagementApi = createApi({
  reducerPath: "WasteManagementApi",
  baseQuery: BaseWithAuth(),
  tagTypes: ["summary"],
  endpoints: (builder) => ({
    // get the info for customer
    getWasteManagement: builder.query<T_WasteManagementData, string>({
      query: () => `customer/${getCustomerId()}/waste-management`,
      transformResponse: (response: APIResponse<T_WasteManagementData>) => {
        return response.data;
      },
      providesTags: ["summary"],
    }),
  }),
});

export const { useGetWasteManagementQuery } = WasteManagementApi;
